export default __webpack_public_path__ + "static/studienkreis-flyer-3a407b375a530f0e085d991b2ce770c2.jpg";